/* eslint-disable */
export default {
  state: {
    isLoading: false,
    showAlert: false,
    alertText: ""
  },
  mutations: {
    toggleLoading(state) {
      state.isLoading = !state.isLoading;
    },
    toggleAlert(state, text) {
      state.showAlert = true;
      state.alertText = text;
      setTimeout(() => {
        state.showAlert = false;
        state.alertText = "";
      }, 5000);
    }
  },
  actions: {
    toggleLoading(context) {
      context.commit("toggleLoading");
    },
    toggleAlert(context, text) {
      context.commit("toggleAlert", text);
    }
  }
};
